import { CulturalOutingInput } from '../../lib/types/models/cultural-outing/cultural-outing-input'
import { API, constructApiUrl } from '../apis.config'
import { restApiClient } from '../rest-api-client'

export function createCulturalOuting(input: CulturalOutingInput & { coachCompanyId?: number }) {
  return restApiClient.url(constructApiUrl(API.culturalOutings.create.url, null)).post(input)
}
